<!-- clickMenu路由跳转方法 -->
<template>

<div v-if="showTip" >
  <el-dialog title="提示" class="showTip_dia" :visible.sync="showTip" :before-close="closeFn" width="30%" center append-to-body>
    <div v-html="content"></div>
    <!-- 下方按钮-底部 -->
    <div class="set-bottom_new no_border">
      <div class="all_float_left"></div>
      <!-- 中心位置 分页器-->
      <div class="bottom_center">
        <!-- 页数大于1才显示 -->

      </div>
      <!-- 按钮统一在右侧 -->
      <div class="all_float_right">
        <el-button type="primary" @click="$emit('showTipFn',true)">确定</el-button>
      
        <el-button @click="$emit('showTipFn',false)">取消</el-button>
      
      </div>
    </div>

  </el-dialog>
</div>
</template>

<script>

export default {
  name:'showTip',
  props:{
    showTip:{
      default:false,
      type:[Boolean]
    },
    content:{
      default:'在这本来是要签章的',
      type:[String,Number]
    },
  },
  data() {
    return {
      show:true,
    };
  },
  mounted: function() {
    
  },
  created(){
  
  },
  components: {},
  methods: {
    closeFn(){
      this.$emit('showTipFn',false)
    },
  }
};
</script>
<style>
  
</style>


// WEBPACK FOOTER //
// src/components/signTip.vue